import { FORMAT_LABELS } from "../../ClassesShared/ClassFormatBadge";

export const CLASS_TEMPLATE_FILTER_GROUPS = [
  {
    id: "template",
    label: "Template",
    filters: [
      {
        id: "status",
        label: "Status",
        type: "checkbox",
        options: [
          { value: "active", label: "Active" },
          { value: "archived", label: "Archived" },
        ],
      },
      {
        id: "format",
        label: "Format",
        type: "checkbox",
        options: Object.entries(FORMAT_LABELS).map(([value, label]) => ({ value, label })),
      },
    ],
  },
];
